<script setup lang="ts">

import NamaIcon from "@/components/icons/NamaIcon.vue";
import Translator from "@/utils/common/Translator.ts";
import type {GetMainMenuItemsParams, MenuItemDef} from "ag-grid-enterprise";
import FieldInfoUtils from "@/utils/common/FieldInfoUtils.ts";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";

const props = defineProps<{ params: MenuItemDef & GetMainMenuItemsParams }>()

async function onClick(e: MouseEvent) {
  if (!e)
    return;
  const el = e.target as HTMLElement;
  if (!el)
    return;
  const entityType = (el.closest("div[data-entity-type]") as HTMLDivElement | undefined)?.dataset.entityType
  if (!entityType)
    return;
  let fieldId = props.params.column?.getColId()
  if (ObjectChecker.isEmptyOrNull(fieldId))
    return;
  const agAllowedValues = props.params.column?.getUserProvidedColDef()?.cellEditorParams?.allowedValues
  const agLimitedAllowedValues = () => {
    if (!agAllowedValues)
      return;
    if (agAllowedValues.length >= 7)
      return "&sall";
    return agAllowedValues.join(",")
  }
  const enumType = () => {
    return {
      enumTypeName: props.params.column?.getUserProvidedColDef()?.cellEditorParams?.enumTypeName,
      allowedValues: agLimitedAllowedValues()
    }
  }
  const blockId = (el.closest("div[data-ag-block-id]") as HTMLDivElement | undefined)?.dataset.agBlockId
  const blockIdWithDot = blockId + ".";
  fieldId = AGGridUtils.decodeColId(fieldId)
  if (ObjectChecker.isNotEmptyOrNull(blockId) && !fieldId.startsWith(blockIdWithDot))
    fieldId = blockIdWithDot + fieldId;
  return await new FieldInfoUtils().showFieldInfo(fieldId, entityType, enumType())
}
</script>
<template>
  <div class="ag-menu-option  hover:[background:--ag-row-hover-color]" role="menuitem" tabindex="-1" @click="onClick">
    <span class="ag-menu-option-part ag-menu-option-icon" role="presentation">
      <NamaIcon default-icon="nm-information" class="tw-size-4"/>
    </span>
    <span class="ag-menu-option-part ag-menu-option-text">
      <span v-text="Translator.translateId(props.params.name)"/>
    </span>
    <span class="ag-menu-option-part ag-menu-option-popup-pointer"/>
    <span data-ref="ePopupPointer" class="ag-menu-option-part ag-menu-option-popup-pointer"/>
  </div>
</template>
